let accessTokenResolver;

export const setAccessTokenResolver = (resolver) => {
  accessTokenResolver = resolver;

  return () => {
    if (accessTokenResolver === resolver) {
      accessTokenResolver = undefined;
    }
  };
};

export const getLatestAccessToken = async () => accessTokenResolver?.();

export const getAuthCoveoUser = (user) => ({
  token: '',
  isLoggedIn: Boolean(user?.isAuth),
  getAccessToken: getLatestAccessToken,
});
